// extracted by mini-css-extract-plugin
module.exports = {"progress-holder":"styles_progress-holder__2Kmud","bar":"styles_bar__ffsiW","show":"styles_show__sBbpR","requirements":"styles_requirements__1E4Lv"};